import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export enum ApprovalStatus {
  Approved = 'APPROVED',
  None = 'NONE',
  StepOneApproved = 'STEP_ONE_APPROVED',
  StepTwoApproved = 'STEP_TWO_APPROVED',
}

export type Authorization = {
  __typename?: 'Authorization';
  isAuthorized?: Maybe<Scalars['Boolean']>;
};

export type AuthorizedStringGroupsInput = {
  userAlias?: InputMaybe<Scalars['String']>;
};

export type Bindle = {
  __typename?: 'Bindle';
  id: Scalars['Int'];
  name: Scalars['String'];
  sourceSystemId?: Maybe<Scalars['String']>;
};

export type CompleteSourceReviewInput = {
  approvalStatus?: InputMaybe<ApprovalStatus>;
  stringGroupName?: InputMaybe<Scalars['String']>;
  userAlias?: InputMaybe<Scalars['String']>;
};

export type CompleteSourceReviewOutput = {
  __typename?: 'CompleteSourceReviewOutput';
  requestId?: Maybe<Scalars['String']>;
};

export type ContentDebugModeMetadata = {
  __typename?: 'ContentDebugModeMetadata';
  cmsName: Scalars['String'];
  contentStage: Scalars['String'];
  locale: Scalars['String'];
  marketplace: Scalars['String'];
  tmsName: Scalars['String'];
  version: Scalars['String'];
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  errorCode: Scalars['Int'];
  errorMessage: Scalars['String'];
};

export type GetAuthorizedStringGroupReviewHistoryInput = {
  userAlias?: InputMaybe<Scalars['String']>;
};

export type GetStringVersionHistoryInput = {
  numberOfVersions?: InputMaybe<Scalars['Int']>;
  stringKey: StringKeyInput;
};

export type GetStringVersionHistoryOutput = {
  __typename?: 'GetStringVersionHistoryOutput';
  versionHistory?: Maybe<Array<StringVersion>>;
};

export type HeadRevision = {
  __typename?: 'HeadRevision';
  content?: Maybe<StringContent>;
  createTimestamp?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  reviewComment?: Maybe<Scalars['String']>;
  sourceReviewStatus?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type HeadRevisionInput = {
  content?: InputMaybe<StringContentInput>;
  createTimestamp?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  reviewComment?: InputMaybe<Scalars['String']>;
  sourceReviewStatus?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type I18nFamily = {
  __typename?: 'I18nFamily';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type IsAuthorized = {
  __typename?: 'IsAuthorized';
  authorized?: Maybe<Scalars['Boolean']>;
};

export type IsAuthorizedForStringGroupInput = {
  resourceName?: InputMaybe<Scalars['String']>;
  userAlias?: InputMaybe<Scalars['String']>;
};

export type IsSourceReviewerInput = {
  userAlias?: InputMaybe<Scalars['String']>;
};

export type IsSourceReviewerOutput = {
  __typename?: 'IsSourceReviewerOutput';
  isReviewer?: Maybe<Scalars['Boolean']>;
};

export type ListStringsInStringGroupInput = {
  filterStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  nextPageToken?: InputMaybe<Scalars['String']>;
  stringGroupName?: InputMaybe<Scalars['String']>;
};

export type ListStringsInStringGroupOutput = {
  __typename?: 'ListStringsInStringGroupOutput';
  nextPageToken?: Maybe<Scalars['String']>;
  strings?: Maybe<Array<Maybe<SourceString>>>;
};

export type Locale = {
  __typename?: 'Locale';
  locale: Scalars['String'];
};

export type LocaleInput = {
  i18nFamilies?: InputMaybe<Scalars['String']>;
};

export type Localization = {
  __typename?: 'Localization';
  canEdit?: Maybe<Scalars['Boolean']>;
  dropDownReasons?: Maybe<Array<Scalars['String']>>;
  explanation?: Maybe<Scalars['String']>;
  lastUpdated?: Maybe<Scalars['Int']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  translation?: Maybe<Scalars['String']>;
  translationStatus?: Maybe<Scalars['String']>;
};

export type LocalizationUpdateInput = {
  localizations?: InputMaybe<Scalars['String']>;
};

export type LocalizationUpdateResponse = {
  __typename?: 'LocalizationUpdateResponse';
  localization: Localization;
  status: TaskStatus;
};

export type Localizations = {
  __typename?: 'Localizations';
  localizationList?: Maybe<Array<Maybe<Localization>>>;
  pageInfo?: Maybe<LocalizationsPageInfo>;
};

export type LocalizationsPageInfo = {
  __typename?: 'LocalizationsPageInfo';
  count: Scalars['Int'];
  limit?: Maybe<Scalars['Int']>;
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type LocalizedContent = {
  __typename?: 'LocalizedContent';
  content: Scalars['String'];
  contentDebugModeMetadata: ContentDebugModeMetadata;
  contentId: Scalars['String'];
};

export type LocalizedPackage = {
  __typename?: 'LocalizedPackage';
  bindle?: Maybe<Bindle>;
  id: Scalars['Int'];
  name: Scalars['String'];
  owner?: Maybe<Owner>;
  packageType?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
};

export type LocalizedPackageInput = {
  i18nFamilies?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Scalars['String']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  direction?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
};

export type MetadataInput = {
  direction?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  completeSourceReview?: Maybe<CompleteSourceReviewOutput>;
  localizationsUpdate: Array<Maybe<LocalizationUpdateResponse>>;
  rejectSourceReview?: Maybe<RejectSourceReviewOutput>;
  updateStringsInStringGroup?: Maybe<UpdateStringsInStringGroupOutput>;
};

export type MutationCompleteSourceReviewArgs = {
  params: CompleteSourceReviewInput;
};

export type MutationLocalizationsUpdateArgs = {
  body: Scalars['String'];
  params: PhraseLocalizationsInput;
};

export type MutationRejectSourceReviewArgs = {
  params: RejectSourceReviewInput;
};

export type MutationUpdateStringsInStringGroupArgs = {
  params: UpdateStringsInStringGroupInput;
};

export type Owner = {
  __typename?: 'Owner';
  id: Scalars['Int'];
  name: Scalars['String'];
  ownerType?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
};

export type OwnerInput = {
  i18nFamilies?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PackageType = {
  __typename?: 'PackageType';
  packageType?: Maybe<Scalars['String']>;
};

export type PackageTypeInput = {
  i18nFamilies?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Scalars['String']>;
  packageType?: InputMaybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Phrase = {
  __typename?: 'Phrase';
  anchorTag: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  i18nFamily?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastUpdated?: Maybe<Scalars['Int']>;
  lastUpdatedBy?: Maybe<Scalars['String']>;
  localizations?: Maybe<Localizations>;
  localizedPackage?: Maybe<Scalars['String']>;
  localizedPackageOriginId?: Maybe<Scalars['String']>;
  localizedPackageTsAceName?: Maybe<Scalars['String']>;
  localizedPackageType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  ownerType?: Maybe<Scalars['String']>;
  psmsId?: Maybe<Scalars['String']>;
  sourceLocale: Scalars['String'];
  sourceText: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  translationsLastUpdated?: Maybe<Scalars['Int']>;
  variant?: Maybe<Variant>;
  variants?: Maybe<Array<Maybe<Variant>>>;
  version?: Maybe<Scalars['String']>;
};

export type PhraseInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']>;
  exactMatch?: InputMaybe<Scalars['Boolean']>;
  i18nFamilies?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  localizedPackages?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  owners?: InputMaybe<Scalars['String']>;
  packageTypes?: InputMaybe<Scalars['String']>;
  psmsIds?: InputMaybe<Scalars['String']>;
  sortDir1?: InputMaybe<Scalars['String']>;
  sortDir2?: InputMaybe<Scalars['String']>;
  sortDir3?: InputMaybe<Scalars['String']>;
  sortDir4?: InputMaybe<Scalars['String']>;
  sortDir5?: InputMaybe<Scalars['String']>;
  sortDir6?: InputMaybe<Scalars['String']>;
  sortKey1?: InputMaybe<Scalars['String']>;
  sortKey2?: InputMaybe<Scalars['String']>;
  sortKey3?: InputMaybe<Scalars['String']>;
  sortKey4?: InputMaybe<Scalars['String']>;
  sortKey5?: InputMaybe<Scalars['String']>;
  sortKey6?: InputMaybe<Scalars['String']>;
  sourceTexts?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Scalars['String']>;
  stringIds?: InputMaybe<Scalars['String']>;
  sudo?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<Scalars['String']>;
};

export type PhraseLocalizationsInput = {
  id: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sudo?: InputMaybe<Scalars['Boolean']>;
  variantId?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['String']>;
};

export type Phrases = {
  __typename?: 'Phrases';
  pageInfo: PageInfo;
  phraseList: Array<Phrase>;
};

export type Query = {
  __typename?: 'Query';
  authorizedStringGroups: StringGroups;
  getAuthorizedStringGroupReviewHistory: StringGroups;
  getStringVersionHistory: GetStringVersionHistoryOutput;
  i18nFamilies: Array<Maybe<I18nFamily>>;
  isAuthorizedForStringGroup: IsAuthorized;
  isSourceReviewer: IsSourceReviewerOutput;
  isSuperuser?: Maybe<Authorization>;
  listStringsInStringGroup: ListStringsInStringGroupOutput;
  locales: Array<Maybe<Locale>>;
  localizedPackages: Array<Maybe<LocalizedPackage>>;
  owners: Array<Maybe<Owner>>;
  packageTypes: Array<Maybe<PackageType>>;
  phrase: Phrase;
  phraseLocalizations: Phrase;
  phraseVariants: Phrase;
  phrases: Phrases;
  sendMessage: SendMessageResult;
  stringGroup: StringGroup;
  translations: Translations;
  whereIsMyString: WimsResponse;
};

export type QueryAuthorizedStringGroupsArgs = {
  params: AuthorizedStringGroupsInput;
};

export type QueryGetAuthorizedStringGroupReviewHistoryArgs = {
  params: GetAuthorizedStringGroupReviewHistoryInput;
};

export type QueryGetStringVersionHistoryArgs = {
  params: GetStringVersionHistoryInput;
};

export type QueryIsAuthorizedForStringGroupArgs = {
  params: IsAuthorizedForStringGroupInput;
};

export type QueryIsSourceReviewerArgs = {
  params: IsSourceReviewerInput;
};

export type QueryListStringsInStringGroupArgs = {
  params: ListStringsInStringGroupInput;
};

export type QueryLocalesArgs = {
  params?: InputMaybe<LocaleInput>;
};

export type QueryLocalizedPackagesArgs = {
  params?: InputMaybe<LocalizedPackageInput>;
};

export type QueryOwnersArgs = {
  params?: InputMaybe<OwnerInput>;
};

export type QueryPackageTypesArgs = {
  params?: InputMaybe<PackageTypeInput>;
};

export type QueryPhraseArgs = {
  params: PhraseLocalizationsInput;
};

export type QueryPhraseLocalizationsArgs = {
  params: PhraseLocalizationsInput;
};

export type QueryPhraseVariantsArgs = {
  params: PhraseLocalizationsInput;
};

export type QueryPhrasesArgs = {
  params: PhraseInput;
};

export type QuerySendMessageArgs = {
  params: SendMessageInput;
};

export type QueryStringGroupArgs = {
  params: StringGroupInput;
};

export type QueryTranslationsArgs = {
  params: TranslationInput;
};

export type QueryWhereIsMyStringArgs = {
  params: WimsRequestInput;
};

export type RejectSourceReviewInput = {
  operatorAlias?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<Scalars['String']>;
  stringGroupName?: InputMaybe<Scalars['String']>;
};

export type RejectSourceReviewOutput = {
  __typename?: 'RejectSourceReviewOutput';
  requestId?: Maybe<Scalars['String']>;
};

export enum ReviewType {
  NoReview = 'NO_REVIEW',
  OneStepReview = 'ONE_STEP_REVIEW',
  TwoStepReview = 'TWO_STEP_REVIEW',
}

export type SendMessageInput = {
  message: Scalars['String'];
  queueName: Scalars['String'];
};

export type SendMessageResult = {
  __typename?: 'SendMessageResult';
  messageId: Scalars['String'];
};

export enum SourceReviewStatus {
  Cancelling = 'CANCELLING',
  Complete = 'COMPLETE',
  Discard = 'DISCARD',
  Draft = 'DRAFT',
  Ingesting = 'INGESTING',
  Pending = 'PENDING',
}

export type SourceString = {
  __typename?: 'SourceString';
  headRevision?: Maybe<HeadRevision>;
  requestId?: Maybe<Scalars['String']>;
  stringKey?: Maybe<StringKey>;
  variants?: Maybe<Array<Maybe<Array<Maybe<SourceStringVariant>>>>>;
};

export type SourceStringInput = {
  headRevision?: InputMaybe<HeadRevisionInput>;
  requestId?: InputMaybe<Scalars['String']>;
  stringKey?: InputMaybe<StringKeyInput>;
  variants?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<SourceStringVariantInput>>>>
  >;
};

export type SourceStringVariant = {
  __typename?: 'SourceStringVariant';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SourceStringVariantInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type StringContent = {
  __typename?: 'StringContent';
  format?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  note?: Maybe<Scalars['String']>;
  resourceContentType?: Maybe<Scalars['String']>;
  translate?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type StringContentInput = {
  format?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<MetadataInput>;
  note?: InputMaybe<Scalars['String']>;
  resourceContentType?: InputMaybe<Scalars['String']>;
  translate?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type StringGroup = {
  __typename?: 'StringGroup';
  approvalStatus?: Maybe<ApprovalStatus>;
  cxFamily?: Maybe<Scalars['String']>;
  cxIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  requestId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<ReviewType>;
  sourceReviewRequestedTimestamp?: Maybe<Scalars['String']>;
  sourceReviewRequester?: Maybe<Scalars['String']>;
  sourceReviewStatus?: Maybe<SourceReviewStatus>;
  stringGroupName?: Maybe<Scalars['String']>;
  updateTimestamp?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type StringGroupInput = {
  stringGroupName?: InputMaybe<Scalars['String']>;
};

export type StringGroups = {
  __typename?: 'StringGroups';
  stringGroups?: Maybe<Array<Maybe<StringGroup>>>;
};

export type StringKey = {
  __typename?: 'StringKey';
  locale?: Maybe<Scalars['String']>;
  stringGroupName?: Maybe<Scalars['String']>;
  stringName?: Maybe<Scalars['String']>;
  stringType?: Maybe<Scalars['String']>;
  variant?: Maybe<Array<Maybe<SourceStringVariant>>>;
};

export type StringKeyInput = {
  locale?: InputMaybe<Scalars['String']>;
  stringGroupName?: InputMaybe<Scalars['String']>;
  stringName?: InputMaybe<Scalars['String']>;
  stringType?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Array<InputMaybe<SourceStringVariantInput>>>;
};

export type StringVersion = {
  __typename?: 'StringVersion';
  contextNote?: Maybe<Scalars['String']>;
  sourceText?: Maybe<Scalars['String']>;
  submittedForTranslation?: Maybe<Scalars['Boolean']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimeStamp?: Maybe<Scalars['String']>;
};

export enum TaskStatus {
  FailedLui = 'FAILED_LUI',
  FailedPanther = 'FAILED_PANTHER',
  FailedUnknown = 'FAILED_UNKNOWN',
  RejectedIncomplete = 'REJECTED_INCOMPLETE',
  RejectedNoChange = 'REJECTED_NO_CHANGE',
  RejectedOutstanding = 'REJECTED_OUTSTANDING',
  RejectedUnauthorized = 'REJECTED_UNAUTHORIZED',
  Succeeded = 'SUCCEEDED',
}

export type Translation = {
  __typename?: 'Translation';
  format?: Maybe<Scalars['String']>;
  localization: Localization;
  phraseId: Scalars['Int'];
  phraseName: Scalars['String'];
  sourceText: Scalars['String'];
};

export type TranslationInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']>;
  exactMatch?: InputMaybe<Scalars['Boolean']>;
  i18nFamilies?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Scalars['String']>;
  localizedPackages?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  owners?: InputMaybe<Scalars['String']>;
  packageTypes?: InputMaybe<Scalars['String']>;
  sudo?: InputMaybe<Scalars['Boolean']>;
  translations?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
};

export type Translations = {
  __typename?: 'Translations';
  pageInfo: PageInfo;
  translationList: Array<Translation>;
};

export type UpdateStringsInStringGroupInput = {
  strings?: InputMaybe<Array<InputMaybe<SourceStringInput>>>;
};

export type UpdateStringsInStringGroupOutput = {
  __typename?: 'UpdateStringsInStringGroupOutput';
  strings?: Maybe<Array<Maybe<SourceString>>>;
  validationErrorMessages?: Maybe<Array<Maybe<Scalars['String']>>>;
  validationSuccess?: Maybe<Scalars['Boolean']>;
};

export type Variant = {
  __typename?: 'Variant';
  category: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type WimsRequestInput = {
  contentId: Scalars['String'];
  locale: Scalars['String'];
  marketplace?: InputMaybe<Scalars['String']>;
};

export type WimsResponse = {
  __typename?: 'WimsResponse';
  errorResponse?: Maybe<ErrorResponse>;
  localizedContent?: Maybe<LocalizedContent>;
};

export type LocalizationsUpdateMutationVariables = Exact<{
  params: PhraseLocalizationsInput;
  body: Scalars['String'];
}>;

export type LocalizationsUpdateMutation = {
  __typename?: 'Mutation';
  localizationsUpdate: Array<{
    __typename?: 'LocalizationUpdateResponse';
    status: TaskStatus;
    localization: {
      __typename?: 'Localization';
      locale?: string | null;
      translationStatus?: string | null;
      translation?: string | null;
      lastUpdated?: number | null;
      lastUpdatedBy?: string | null;
      canEdit?: boolean | null;
    };
  } | null>;
};

export type CompleteSourceReviewMutationVariables = Exact<{
  params: CompleteSourceReviewInput;
}>;

export type CompleteSourceReviewMutation = {
  __typename?: 'Mutation';
  completeSourceReview?: {
    __typename?: 'CompleteSourceReviewOutput';
    requestId?: string | null;
  } | null;
};

export type RejectSourceReviewMutationVariables = Exact<{
  params: RejectSourceReviewInput;
}>;

export type RejectSourceReviewMutation = {
  __typename?: 'Mutation';
  rejectSourceReview?: {
    __typename?: 'RejectSourceReviewOutput';
    requestId?: string | null;
  } | null;
};

export type UpdateStringsInStringGroupMutationVariables = Exact<{
  params: UpdateStringsInStringGroupInput;
}>;

export type UpdateStringsInStringGroupMutation = {
  __typename?: 'Mutation';
  updateStringsInStringGroup?: {
    __typename?: 'UpdateStringsInStringGroupOutput';
    validationErrorMessages?: Array<string | null> | null;
    validationSuccess?: boolean | null;
    strings?: Array<{
      __typename?: 'SourceString';
      requestId?: string | null;
      stringKey?: {
        __typename?: 'StringKey';
        stringName?: string | null;
        stringType?: string | null;
        locale?: string | null;
        variant?: Array<{
          __typename?: 'SourceStringVariant';
          key: string;
          value: string;
        } | null> | null;
      } | null;
      headRevision?: {
        __typename?: 'HeadRevision';
        sourceReviewStatus?: string | null;
        reviewComment?: string | null;
        createTimestamp?: string | null;
        createdBy?: string | null;
        version?: number | null;
        content?: {
          __typename?: 'StringContent';
          format?: string | null;
          value?: string | null;
          resourceContentType?: string | null;
          translate?: boolean | null;
          note?: string | null;
          metadata?: {
            __typename?: 'Metadata';
            direction?: string | null;
            format?: string | null;
            mimeType?: string | null;
          } | null;
        } | null;
      } | null;
      variants?: Array<Array<{
        __typename?: 'SourceStringVariant';
        key: string;
        value: string;
      } | null> | null> | null;
    } | null> | null;
  } | null;
};

export type SuperuserQueryVariables = Exact<{ [key: string]: never }>;

export type SuperuserQuery = {
  __typename?: 'Query';
  isSuperuser?: {
    __typename?: 'Authorization';
    isAuthorized?: boolean | null;
  } | null;
};

export type AllI18nFamiliesQueryVariables = Exact<{ [key: string]: never }>;

export type AllI18nFamiliesQuery = {
  __typename?: 'Query';
  i18nFamilies: Array<{
    __typename?: 'I18nFamily';
    id: number;
    name: string;
  } | null>;
};

export type GetLocalesQueryVariables = Exact<{
  params: LocaleInput;
}>;

export type GetLocalesQuery = {
  __typename?: 'Query';
  locales: Array<{ __typename?: 'Locale'; locale: string } | null>;
};

export type GetLocalizedPackagesQueryVariables = Exact<{
  params?: InputMaybe<LocalizedPackageInput>;
}>;

export type GetLocalizedPackagesQuery = {
  __typename?: 'Query';
  localizedPackages: Array<{
    __typename?: 'LocalizedPackage';
    id: number;
    name: string;
  } | null>;
};

export type GetOwnersQueryVariables = Exact<{
  params?: InputMaybe<OwnerInput>;
}>;

export type GetOwnersQuery = {
  __typename?: 'Query';
  owners: Array<{ __typename?: 'Owner'; id: number; name: string } | null>;
};

export type GetPackageTypesQueryVariables = Exact<{
  params?: InputMaybe<PackageTypeInput>;
}>;

export type GetPackageTypesQuery = {
  __typename?: 'Query';
  packageTypes: Array<{
    __typename?: 'PackageType';
    packageType?: string | null;
  } | null>;
};

export type PhraseQueryVariables = Exact<{
  params: PhraseLocalizationsInput;
}>;

export type PhraseQuery = {
  __typename?: 'Query';
  phrase: {
    __typename?: 'Phrase';
    id: number;
    name: string;
    anchorTag: string;
    sourceText: string;
    sourceLocale: string;
    context?: string | null;
    version?: string | null;
    created?: number | null;
    createdBy?: string | null;
    lastUpdated?: number | null;
    lastUpdatedBy?: string | null;
    owner?: string | null;
    ownerType?: string | null;
    i18nFamily?: string | null;
    localizedPackage?: string | null;
    localizedPackageType?: string | null;
    localizedPackageOriginId?: string | null;
    localizedPackageTsAceName?: string | null;
    psmsId?: string | null;
    format?: string | null;
    variant?: {
      __typename?: 'Variant';
      id: number;
      category: string;
      name: string;
    } | null;
  };
};

export type PhrasesQueryVariables = Exact<{
  params: PhraseInput;
}>;

export type PhrasesQuery = {
  __typename?: 'Query';
  phrases: {
    __typename?: 'Phrases';
    phraseList: Array<{
      __typename?: 'Phrase';
      id: number;
      name: string;
      sourceText: string;
      sourceLocale: string;
      owner?: string | null;
      i18nFamily?: string | null;
      localizedPackageType?: string | null;
      localizedPackage?: string | null;
      translationsLastUpdated?: number | null;
      status?: string | null;
      format?: string | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      offset: number;
      limit: number;
      count: number;
      totalCount: number;
    };
  };
};

export type PhraseLocalizationsQueryVariables = Exact<{
  params: PhraseLocalizationsInput;
}>;

export type PhraseLocalizationsQuery = {
  __typename?: 'Query';
  phrase: {
    __typename?: 'Phrase';
    id: number;
    variant?: { __typename?: 'Variant'; id: number } | null;
    localizations?: {
      __typename?: 'Localizations';
      localizationList?: Array<{
        __typename?: 'Localization';
        locale?: string | null;
        translationStatus?: string | null;
        translation?: string | null;
        lastUpdated?: number | null;
        lastUpdatedBy?: string | null;
        canEdit?: boolean | null;
      } | null> | null;
      pageInfo?: {
        __typename?: 'LocalizationsPageInfo';
        offset: number;
        limit?: number | null;
        count: number;
        totalCount: number;
      } | null;
    } | null;
  };
};

export type PhraseVariantsQueryVariables = Exact<{
  params: PhraseLocalizationsInput;
}>;

export type PhraseVariantsQuery = {
  __typename?: 'Query';
  phrase: {
    __typename?: 'Phrase';
    id: number;
    variants?: Array<{
      __typename?: 'Variant';
      id: number;
      category: string;
      name: string;
    } | null> | null;
  };
};

export type SendMessageQueryVariables = Exact<{
  params: SendMessageInput;
}>;

export type SendMessageQuery = {
  __typename?: 'Query';
  sendMessage: { __typename?: 'SendMessageResult'; messageId: string };
};

export type IsSourceReviewerQueryVariables = Exact<{
  params: IsSourceReviewerInput;
}>;

export type IsSourceReviewerQuery = {
  __typename?: 'Query';
  isSourceReviewer: {
    __typename?: 'IsSourceReviewerOutput';
    isReviewer?: boolean | null;
  };
};

export type ListStringsInStringGroupQueryVariables = Exact<{
  params: ListStringsInStringGroupInput;
}>;

export type ListStringsInStringGroupQuery = {
  __typename?: 'Query';
  listStringsInStringGroup: {
    __typename?: 'ListStringsInStringGroupOutput';
    nextPageToken?: string | null;
    strings?: Array<{
      __typename?: 'SourceString';
      requestId?: string | null;
      stringKey?: {
        __typename?: 'StringKey';
        stringName?: string | null;
        stringType?: string | null;
        stringGroupName?: string | null;
        locale?: string | null;
        variant?: Array<{
          __typename?: 'SourceStringVariant';
          key: string;
          value: string;
        } | null> | null;
      } | null;
      headRevision?: {
        __typename?: 'HeadRevision';
        sourceReviewStatus?: string | null;
        reviewComment?: string | null;
        createTimestamp?: string | null;
        createdBy?: string | null;
        version?: number | null;
        content?: {
          __typename?: 'StringContent';
          format?: string | null;
          value?: string | null;
          resourceContentType?: string | null;
          translate?: boolean | null;
          note?: string | null;
          metadata?: {
            __typename?: 'Metadata';
            direction?: string | null;
            format?: string | null;
            mimeType?: string | null;
          } | null;
        } | null;
      } | null;
      variants?: Array<Array<{
        __typename?: 'SourceStringVariant';
        key: string;
        value: string;
      } | null> | null> | null;
    } | null> | null;
  };
};

export type GetStringVersionHistoryQueryVariables = Exact<{
  params: GetStringVersionHistoryInput;
}>;

export type GetStringVersionHistoryQuery = {
  __typename?: 'Query';
  getStringVersionHistory: {
    __typename?: 'GetStringVersionHistoryOutput';
    versionHistory?: Array<{
      __typename?: 'StringVersion';
      sourceText?: string | null;
      contextNote?: string | null;
      updatedBy?: string | null;
      updatedTimeStamp?: string | null;
      submittedForTranslation?: boolean | null;
    }> | null;
  };
};

export type AuthorizedStringGroupsQueryVariables = Exact<{
  params: AuthorizedStringGroupsInput;
}>;

export type AuthorizedStringGroupsQuery = {
  __typename?: 'Query';
  authorizedStringGroups: {
    __typename?: 'StringGroups';
    stringGroups?: Array<{
      __typename?: 'StringGroup';
      stringGroupName?: string | null;
      cxFamily?: string | null;
      cxIds?: Array<string | null> | null;
      requestId?: string | null;
      sourceReviewRequester?: string | null;
      sourceReviewRequestedTimestamp?: string | null;
      reviewType?: ReviewType | null;
      approvalStatus?: ApprovalStatus | null;
    } | null> | null;
  };
};

export type GetAuthorizedStringGroupReviewHistoryQueryVariables = Exact<{
  params: GetAuthorizedStringGroupReviewHistoryInput;
}>;

export type GetAuthorizedStringGroupReviewHistoryQuery = {
  __typename?: 'Query';
  getAuthorizedStringGroupReviewHistory: {
    __typename?: 'StringGroups';
    stringGroups?: Array<{
      __typename?: 'StringGroup';
      stringGroupName?: string | null;
      requestId?: string | null;
      sourceReviewRequester?: string | null;
      sourceReviewRequestedTimestamp?: string | null;
      updatedBy?: string | null;
      updateTimestamp?: string | null;
      sourceReviewStatus?: SourceReviewStatus | null;
    } | null> | null;
  };
};

export type StringGroupQueryVariables = Exact<{
  params: StringGroupInput;
}>;

export type StringGroupQuery = {
  __typename?: 'Query';
  stringGroup: {
    __typename?: 'StringGroup';
    stringGroupName?: string | null;
    cxFamily?: string | null;
    cxIds?: Array<string | null> | null;
    requestId?: string | null;
    sourceReviewRequester?: string | null;
    sourceReviewRequestedTimestamp?: string | null;
    reviewType?: ReviewType | null;
    approvalStatus?: ApprovalStatus | null;
  };
};

export type IsAuthorizedForStringGroupQueryVariables = Exact<{
  params: IsAuthorizedForStringGroupInput;
}>;

export type IsAuthorizedForStringGroupQuery = {
  __typename?: 'Query';
  isAuthorizedForStringGroup: {
    __typename?: 'IsAuthorized';
    authorized?: boolean | null;
  };
};

export type TranslationsQueryVariables = Exact<{
  params: TranslationInput;
}>;

export type TranslationsQuery = {
  __typename?: 'Query';
  translations: {
    __typename?: 'Translations';
    translationList: Array<{
      __typename?: 'Translation';
      phraseId: number;
      phraseName: string;
      sourceText: string;
      format?: string | null;
      localization: {
        __typename?: 'Localization';
        locale?: string | null;
        translation?: string | null;
        lastUpdated?: number | null;
        lastUpdatedBy?: string | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      offset: number;
      limit: number;
      count: number;
      totalCount: number;
    };
  };
};

export type WhereIsMyStringQueryVariables = Exact<{
  params: WimsRequestInput;
}>;

export type WhereIsMyStringQuery = {
  __typename?: 'Query';
  whereIsMyString: {
    __typename?: 'WimsResponse';
    localizedContent?: {
      __typename?: 'LocalizedContent';
      content: string;
      contentId: string;
      contentDebugModeMetadata: {
        __typename?: 'ContentDebugModeMetadata';
        tmsName: string;
        marketplace: string;
        cmsName: string;
        locale: string;
        contentStage: string;
        version: string;
      };
    } | null;
    errorResponse?: {
      __typename?: 'ErrorResponse';
      errorMessage: string;
      errorCode: number;
    } | null;
  };
};

export const LocalizationsUpdateDocument = gql`
  mutation LocalizationsUpdate(
    $params: PhraseLocalizationsInput!
    $body: String!
  ) {
    localizationsUpdate(params: $params, body: $body) {
      localization {
        locale
        translationStatus
        translation
        lastUpdated
        lastUpdatedBy
        canEdit
      }
      status
    }
  }
`;
export type LocalizationsUpdateMutationFn = Apollo.MutationFunction<
  LocalizationsUpdateMutation,
  LocalizationsUpdateMutationVariables
>;

/**
 * __useLocalizationsUpdateMutation__
 *
 * To run a mutation, you first call `useLocalizationsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocalizationsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [localizationsUpdateMutation, { data, loading, error }] = useLocalizationsUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useLocalizationsUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LocalizationsUpdateMutation,
    LocalizationsUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LocalizationsUpdateMutation,
    LocalizationsUpdateMutationVariables
  >(LocalizationsUpdateDocument, options);
}
export type LocalizationsUpdateMutationHookResult = ReturnType<
  typeof useLocalizationsUpdateMutation
>;
export type LocalizationsUpdateMutationResult =
  Apollo.MutationResult<LocalizationsUpdateMutation>;
export type LocalizationsUpdateMutationOptions = Apollo.BaseMutationOptions<
  LocalizationsUpdateMutation,
  LocalizationsUpdateMutationVariables
>;
export const CompleteSourceReviewDocument = gql`
  mutation CompleteSourceReview($params: CompleteSourceReviewInput!) {
    completeSourceReview(params: $params) {
      requestId
    }
  }
`;
export type CompleteSourceReviewMutationFn = Apollo.MutationFunction<
  CompleteSourceReviewMutation,
  CompleteSourceReviewMutationVariables
>;

/**
 * __useCompleteSourceReviewMutation__
 *
 * To run a mutation, you first call `useCompleteSourceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSourceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSourceReviewMutation, { data, loading, error }] = useCompleteSourceReviewMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCompleteSourceReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteSourceReviewMutation,
    CompleteSourceReviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteSourceReviewMutation,
    CompleteSourceReviewMutationVariables
  >(CompleteSourceReviewDocument, options);
}
export type CompleteSourceReviewMutationHookResult = ReturnType<
  typeof useCompleteSourceReviewMutation
>;
export type CompleteSourceReviewMutationResult =
  Apollo.MutationResult<CompleteSourceReviewMutation>;
export type CompleteSourceReviewMutationOptions = Apollo.BaseMutationOptions<
  CompleteSourceReviewMutation,
  CompleteSourceReviewMutationVariables
>;
export const RejectSourceReviewDocument = gql`
  mutation RejectSourceReview($params: RejectSourceReviewInput!) {
    rejectSourceReview(params: $params) {
      requestId
    }
  }
`;
export type RejectSourceReviewMutationFn = Apollo.MutationFunction<
  RejectSourceReviewMutation,
  RejectSourceReviewMutationVariables
>;

/**
 * __useRejectSourceReviewMutation__
 *
 * To run a mutation, you first call `useRejectSourceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectSourceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectSourceReviewMutation, { data, loading, error }] = useRejectSourceReviewMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useRejectSourceReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectSourceReviewMutation,
    RejectSourceReviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RejectSourceReviewMutation,
    RejectSourceReviewMutationVariables
  >(RejectSourceReviewDocument, options);
}
export type RejectSourceReviewMutationHookResult = ReturnType<
  typeof useRejectSourceReviewMutation
>;
export type RejectSourceReviewMutationResult =
  Apollo.MutationResult<RejectSourceReviewMutation>;
export type RejectSourceReviewMutationOptions = Apollo.BaseMutationOptions<
  RejectSourceReviewMutation,
  RejectSourceReviewMutationVariables
>;
export const UpdateStringsInStringGroupDocument = gql`
  mutation UpdateStringsInStringGroup(
    $params: UpdateStringsInStringGroupInput!
  ) {
    updateStringsInStringGroup(params: $params) {
      strings {
        stringKey {
          stringName
          stringType
          locale
          variant {
            key
            value
          }
        }
        headRevision {
          sourceReviewStatus
          reviewComment
          createTimestamp
          createdBy
          version
          content {
            format
            value
            resourceContentType
            translate
            note
            metadata {
              direction
              format
              mimeType
            }
          }
        }
        variants {
          key
          value
        }
        requestId
      }
      validationErrorMessages
      validationSuccess
    }
  }
`;
export type UpdateStringsInStringGroupMutationFn = Apollo.MutationFunction<
  UpdateStringsInStringGroupMutation,
  UpdateStringsInStringGroupMutationVariables
>;

/**
 * __useUpdateStringsInStringGroupMutation__
 *
 * To run a mutation, you first call `useUpdateStringsInStringGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStringsInStringGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStringsInStringGroupMutation, { data, loading, error }] = useUpdateStringsInStringGroupMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateStringsInStringGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStringsInStringGroupMutation,
    UpdateStringsInStringGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateStringsInStringGroupMutation,
    UpdateStringsInStringGroupMutationVariables
  >(UpdateStringsInStringGroupDocument, options);
}
export type UpdateStringsInStringGroupMutationHookResult = ReturnType<
  typeof useUpdateStringsInStringGroupMutation
>;
export type UpdateStringsInStringGroupMutationResult =
  Apollo.MutationResult<UpdateStringsInStringGroupMutation>;
export type UpdateStringsInStringGroupMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateStringsInStringGroupMutation,
    UpdateStringsInStringGroupMutationVariables
  >;
export const SuperuserDocument = gql`
  query Superuser {
    isSuperuser {
      isAuthorized
    }
  }
`;

/**
 * __useSuperuserQuery__
 *
 * To run a query within a React component, call `useSuperuserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperuserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperuserQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperuserQuery(
  baseOptions?: Apollo.QueryHookOptions<SuperuserQuery, SuperuserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SuperuserQuery, SuperuserQueryVariables>(
    SuperuserDocument,
    options
  );
}
export function useSuperuserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SuperuserQuery,
    SuperuserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SuperuserQuery, SuperuserQueryVariables>(
    SuperuserDocument,
    options
  );
}
export type SuperuserQueryHookResult = ReturnType<typeof useSuperuserQuery>;
export type SuperuserLazyQueryHookResult = ReturnType<
  typeof useSuperuserLazyQuery
>;
export type SuperuserQueryResult = Apollo.QueryResult<
  SuperuserQuery,
  SuperuserQueryVariables
>;
export const AllI18nFamiliesDocument = gql`
  query AllI18nFamilies {
    i18nFamilies {
      id
      name
    }
  }
`;

/**
 * __useAllI18nFamiliesQuery__
 *
 * To run a query within a React component, call `useAllI18nFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllI18nFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllI18nFamiliesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllI18nFamiliesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllI18nFamiliesQuery,
    AllI18nFamiliesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllI18nFamiliesQuery, AllI18nFamiliesQueryVariables>(
    AllI18nFamiliesDocument,
    options
  );
}
export function useAllI18nFamiliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllI18nFamiliesQuery,
    AllI18nFamiliesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AllI18nFamiliesQuery,
    AllI18nFamiliesQueryVariables
  >(AllI18nFamiliesDocument, options);
}
export type AllI18nFamiliesQueryHookResult = ReturnType<
  typeof useAllI18nFamiliesQuery
>;
export type AllI18nFamiliesLazyQueryHookResult = ReturnType<
  typeof useAllI18nFamiliesLazyQuery
>;
export type AllI18nFamiliesQueryResult = Apollo.QueryResult<
  AllI18nFamiliesQuery,
  AllI18nFamiliesQueryVariables
>;
export const GetLocalesDocument = gql`
  query GetLocales($params: LocaleInput!) {
    locales(params: $params) {
      locale
    }
  }
`;

/**
 * __useGetLocalesQuery__
 *
 * To run a query within a React component, call `useGetLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetLocalesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocalesQuery,
    GetLocalesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLocalesQuery, GetLocalesQueryVariables>(
    GetLocalesDocument,
    options
  );
}
export function useGetLocalesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocalesQuery,
    GetLocalesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLocalesQuery, GetLocalesQueryVariables>(
    GetLocalesDocument,
    options
  );
}
export type GetLocalesQueryHookResult = ReturnType<typeof useGetLocalesQuery>;
export type GetLocalesLazyQueryHookResult = ReturnType<
  typeof useGetLocalesLazyQuery
>;
export type GetLocalesQueryResult = Apollo.QueryResult<
  GetLocalesQuery,
  GetLocalesQueryVariables
>;
export const GetLocalizedPackagesDocument = gql`
  query GetLocalizedPackages($params: LocalizedPackageInput) {
    localizedPackages(params: $params) {
      id
      name
    }
  }
`;

/**
 * __useGetLocalizedPackagesQuery__
 *
 * To run a query within a React component, call `useGetLocalizedPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizedPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizedPackagesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetLocalizedPackagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLocalizedPackagesQuery,
    GetLocalizedPackagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocalizedPackagesQuery,
    GetLocalizedPackagesQueryVariables
  >(GetLocalizedPackagesDocument, options);
}
export function useGetLocalizedPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocalizedPackagesQuery,
    GetLocalizedPackagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocalizedPackagesQuery,
    GetLocalizedPackagesQueryVariables
  >(GetLocalizedPackagesDocument, options);
}
export type GetLocalizedPackagesQueryHookResult = ReturnType<
  typeof useGetLocalizedPackagesQuery
>;
export type GetLocalizedPackagesLazyQueryHookResult = ReturnType<
  typeof useGetLocalizedPackagesLazyQuery
>;
export type GetLocalizedPackagesQueryResult = Apollo.QueryResult<
  GetLocalizedPackagesQuery,
  GetLocalizedPackagesQueryVariables
>;
export const GetOwnersDocument = gql`
  query GetOwners($params: OwnerInput) {
    owners(params: $params) {
      id
      name
    }
  }
`;

/**
 * __useGetOwnersQuery__
 *
 * To run a query within a React component, call `useGetOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnersQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetOwnersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOwnersQuery, GetOwnersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOwnersQuery, GetOwnersQueryVariables>(
    GetOwnersDocument,
    options
  );
}
export function useGetOwnersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOwnersQuery,
    GetOwnersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOwnersQuery, GetOwnersQueryVariables>(
    GetOwnersDocument,
    options
  );
}
export type GetOwnersQueryHookResult = ReturnType<typeof useGetOwnersQuery>;
export type GetOwnersLazyQueryHookResult = ReturnType<
  typeof useGetOwnersLazyQuery
>;
export type GetOwnersQueryResult = Apollo.QueryResult<
  GetOwnersQuery,
  GetOwnersQueryVariables
>;
export const GetPackageTypesDocument = gql`
  query GetPackageTypes($params: PackageTypeInput) {
    packageTypes(params: $params) {
      packageType
    }
  }
`;

/**
 * __useGetPackageTypesQuery__
 *
 * To run a query within a React component, call `useGetPackageTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageTypesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetPackageTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPackageTypesQuery,
    GetPackageTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPackageTypesQuery, GetPackageTypesQueryVariables>(
    GetPackageTypesDocument,
    options
  );
}
export function useGetPackageTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPackageTypesQuery,
    GetPackageTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPackageTypesQuery,
    GetPackageTypesQueryVariables
  >(GetPackageTypesDocument, options);
}
export type GetPackageTypesQueryHookResult = ReturnType<
  typeof useGetPackageTypesQuery
>;
export type GetPackageTypesLazyQueryHookResult = ReturnType<
  typeof useGetPackageTypesLazyQuery
>;
export type GetPackageTypesQueryResult = Apollo.QueryResult<
  GetPackageTypesQuery,
  GetPackageTypesQueryVariables
>;
export const PhraseDocument = gql`
  query Phrase($params: PhraseLocalizationsInput!) {
    phrase(params: $params) {
      id
      name
      anchorTag
      sourceText
      sourceLocale
      context
      version
      created
      createdBy
      lastUpdated
      lastUpdatedBy
      owner
      ownerType
      i18nFamily
      localizedPackage
      localizedPackageType
      localizedPackageOriginId
      localizedPackageTsAceName
      psmsId
      format
      variant {
        id
        category
        name
      }
    }
  }
`;

/**
 * __usePhraseQuery__
 *
 * To run a query within a React component, call `usePhraseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhraseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhraseQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePhraseQuery(
  baseOptions: Apollo.QueryHookOptions<PhraseQuery, PhraseQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PhraseQuery, PhraseQueryVariables>(
    PhraseDocument,
    options
  );
}
export function usePhraseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PhraseQuery, PhraseQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PhraseQuery, PhraseQueryVariables>(
    PhraseDocument,
    options
  );
}
export type PhraseQueryHookResult = ReturnType<typeof usePhraseQuery>;
export type PhraseLazyQueryHookResult = ReturnType<typeof usePhraseLazyQuery>;
export type PhraseQueryResult = Apollo.QueryResult<
  PhraseQuery,
  PhraseQueryVariables
>;
export const PhrasesDocument = gql`
  query Phrases($params: PhraseInput!) {
    phrases(params: $params) {
      phraseList {
        id
        name
        sourceText
        sourceLocale
        owner
        i18nFamily
        localizedPackageType
        localizedPackage
        translationsLastUpdated
        status
        format
      }
      pageInfo {
        offset
        limit
        count
        totalCount
      }
    }
  }
`;

/**
 * __usePhrasesQuery__
 *
 * To run a query within a React component, call `usePhrasesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhrasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhrasesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePhrasesQuery(
  baseOptions: Apollo.QueryHookOptions<PhrasesQuery, PhrasesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PhrasesQuery, PhrasesQueryVariables>(
    PhrasesDocument,
    options
  );
}
export function usePhrasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PhrasesQuery, PhrasesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PhrasesQuery, PhrasesQueryVariables>(
    PhrasesDocument,
    options
  );
}
export type PhrasesQueryHookResult = ReturnType<typeof usePhrasesQuery>;
export type PhrasesLazyQueryHookResult = ReturnType<typeof usePhrasesLazyQuery>;
export type PhrasesQueryResult = Apollo.QueryResult<
  PhrasesQuery,
  PhrasesQueryVariables
>;
export const PhraseLocalizationsDocument = gql`
  query PhraseLocalizations($params: PhraseLocalizationsInput!) {
    phrase: phraseLocalizations(params: $params) {
      id
      variant {
        id
      }
      localizations {
        localizationList {
          locale
          translationStatus
          translation
          lastUpdated
          lastUpdatedBy
          canEdit
        }
        pageInfo {
          offset
          limit
          count
          totalCount
        }
      }
    }
  }
`;

/**
 * __usePhraseLocalizationsQuery__
 *
 * To run a query within a React component, call `usePhraseLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhraseLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhraseLocalizationsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePhraseLocalizationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PhraseLocalizationsQuery,
    PhraseLocalizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PhraseLocalizationsQuery,
    PhraseLocalizationsQueryVariables
  >(PhraseLocalizationsDocument, options);
}
export function usePhraseLocalizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PhraseLocalizationsQuery,
    PhraseLocalizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PhraseLocalizationsQuery,
    PhraseLocalizationsQueryVariables
  >(PhraseLocalizationsDocument, options);
}
export type PhraseLocalizationsQueryHookResult = ReturnType<
  typeof usePhraseLocalizationsQuery
>;
export type PhraseLocalizationsLazyQueryHookResult = ReturnType<
  typeof usePhraseLocalizationsLazyQuery
>;
export type PhraseLocalizationsQueryResult = Apollo.QueryResult<
  PhraseLocalizationsQuery,
  PhraseLocalizationsQueryVariables
>;
export const PhraseVariantsDocument = gql`
  query PhraseVariants($params: PhraseLocalizationsInput!) {
    phrase: phraseVariants(params: $params) {
      id
      variants {
        id
        category
        name
      }
    }
  }
`;

/**
 * __usePhraseVariantsQuery__
 *
 * To run a query within a React component, call `usePhraseVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhraseVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhraseVariantsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePhraseVariantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PhraseVariantsQuery,
    PhraseVariantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PhraseVariantsQuery, PhraseVariantsQueryVariables>(
    PhraseVariantsDocument,
    options
  );
}
export function usePhraseVariantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PhraseVariantsQuery,
    PhraseVariantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PhraseVariantsQuery, PhraseVariantsQueryVariables>(
    PhraseVariantsDocument,
    options
  );
}
export type PhraseVariantsQueryHookResult = ReturnType<
  typeof usePhraseVariantsQuery
>;
export type PhraseVariantsLazyQueryHookResult = ReturnType<
  typeof usePhraseVariantsLazyQuery
>;
export type PhraseVariantsQueryResult = Apollo.QueryResult<
  PhraseVariantsQuery,
  PhraseVariantsQueryVariables
>;
export const SendMessageDocument = gql`
  query SendMessage($params: SendMessageInput!) {
    sendMessage(params: $params) {
      messageId
    }
  }
`;

/**
 * __useSendMessageQuery__
 *
 * To run a query within a React component, call `useSendMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendMessageQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSendMessageQuery(
  baseOptions: Apollo.QueryHookOptions<
    SendMessageQuery,
    SendMessageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SendMessageQuery, SendMessageQueryVariables>(
    SendMessageDocument,
    options
  );
}
export function useSendMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendMessageQuery,
    SendMessageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SendMessageQuery, SendMessageQueryVariables>(
    SendMessageDocument,
    options
  );
}
export type SendMessageQueryHookResult = ReturnType<typeof useSendMessageQuery>;
export type SendMessageLazyQueryHookResult = ReturnType<
  typeof useSendMessageLazyQuery
>;
export type SendMessageQueryResult = Apollo.QueryResult<
  SendMessageQuery,
  SendMessageQueryVariables
>;
export const IsSourceReviewerDocument = gql`
  query IsSourceReviewer($params: IsSourceReviewerInput!) {
    isSourceReviewer(params: $params) {
      isReviewer
    }
  }
`;

/**
 * __useIsSourceReviewerQuery__
 *
 * To run a query within a React component, call `useIsSourceReviewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSourceReviewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSourceReviewerQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useIsSourceReviewerQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsSourceReviewerQuery,
    IsSourceReviewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IsSourceReviewerQuery, IsSourceReviewerQueryVariables>(
    IsSourceReviewerDocument,
    options
  );
}
export function useIsSourceReviewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsSourceReviewerQuery,
    IsSourceReviewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IsSourceReviewerQuery,
    IsSourceReviewerQueryVariables
  >(IsSourceReviewerDocument, options);
}
export type IsSourceReviewerQueryHookResult = ReturnType<
  typeof useIsSourceReviewerQuery
>;
export type IsSourceReviewerLazyQueryHookResult = ReturnType<
  typeof useIsSourceReviewerLazyQuery
>;
export type IsSourceReviewerQueryResult = Apollo.QueryResult<
  IsSourceReviewerQuery,
  IsSourceReviewerQueryVariables
>;
export const ListStringsInStringGroupDocument = gql`
  query ListStringsInStringGroup($params: ListStringsInStringGroupInput!) {
    listStringsInStringGroup(params: $params) {
      strings {
        stringKey {
          stringName
          stringType
          stringGroupName
          locale
          variant {
            key
            value
          }
        }
        headRevision {
          sourceReviewStatus
          reviewComment
          createTimestamp
          createdBy
          version
          content {
            format
            value
            resourceContentType
            translate
            note
            metadata {
              direction
              format
              mimeType
            }
          }
        }
        variants {
          key
          value
        }
        requestId
      }
      nextPageToken
    }
  }
`;

/**
 * __useListStringsInStringGroupQuery__
 *
 * To run a query within a React component, call `useListStringsInStringGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStringsInStringGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStringsInStringGroupQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListStringsInStringGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListStringsInStringGroupQuery,
    ListStringsInStringGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListStringsInStringGroupQuery,
    ListStringsInStringGroupQueryVariables
  >(ListStringsInStringGroupDocument, options);
}
export function useListStringsInStringGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListStringsInStringGroupQuery,
    ListStringsInStringGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListStringsInStringGroupQuery,
    ListStringsInStringGroupQueryVariables
  >(ListStringsInStringGroupDocument, options);
}
export type ListStringsInStringGroupQueryHookResult = ReturnType<
  typeof useListStringsInStringGroupQuery
>;
export type ListStringsInStringGroupLazyQueryHookResult = ReturnType<
  typeof useListStringsInStringGroupLazyQuery
>;
export type ListStringsInStringGroupQueryResult = Apollo.QueryResult<
  ListStringsInStringGroupQuery,
  ListStringsInStringGroupQueryVariables
>;
export const GetStringVersionHistoryDocument = gql`
  query GetStringVersionHistory($params: GetStringVersionHistoryInput!) {
    getStringVersionHistory(params: $params) {
      versionHistory {
        sourceText
        contextNote
        updatedBy
        updatedTimeStamp
        submittedForTranslation
      }
    }
  }
`;

/**
 * __useGetStringVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetStringVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStringVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStringVersionHistoryQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetStringVersionHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStringVersionHistoryQuery,
    GetStringVersionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStringVersionHistoryQuery,
    GetStringVersionHistoryQueryVariables
  >(GetStringVersionHistoryDocument, options);
}
export function useGetStringVersionHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStringVersionHistoryQuery,
    GetStringVersionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStringVersionHistoryQuery,
    GetStringVersionHistoryQueryVariables
  >(GetStringVersionHistoryDocument, options);
}
export type GetStringVersionHistoryQueryHookResult = ReturnType<
  typeof useGetStringVersionHistoryQuery
>;
export type GetStringVersionHistoryLazyQueryHookResult = ReturnType<
  typeof useGetStringVersionHistoryLazyQuery
>;
export type GetStringVersionHistoryQueryResult = Apollo.QueryResult<
  GetStringVersionHistoryQuery,
  GetStringVersionHistoryQueryVariables
>;
export const AuthorizedStringGroupsDocument = gql`
  query AuthorizedStringGroups($params: AuthorizedStringGroupsInput!) {
    authorizedStringGroups(params: $params) {
      stringGroups {
        stringGroupName
        cxFamily
        cxIds
        requestId
        sourceReviewRequester
        sourceReviewRequestedTimestamp
        reviewType
        approvalStatus
      }
    }
  }
`;

/**
 * __useAuthorizedStringGroupsQuery__
 *
 * To run a query within a React component, call `useAuthorizedStringGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizedStringGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizedStringGroupsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAuthorizedStringGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AuthorizedStringGroupsQuery,
    AuthorizedStringGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AuthorizedStringGroupsQuery,
    AuthorizedStringGroupsQueryVariables
  >(AuthorizedStringGroupsDocument, options);
}
export function useAuthorizedStringGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthorizedStringGroupsQuery,
    AuthorizedStringGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AuthorizedStringGroupsQuery,
    AuthorizedStringGroupsQueryVariables
  >(AuthorizedStringGroupsDocument, options);
}
export type AuthorizedStringGroupsQueryHookResult = ReturnType<
  typeof useAuthorizedStringGroupsQuery
>;
export type AuthorizedStringGroupsLazyQueryHookResult = ReturnType<
  typeof useAuthorizedStringGroupsLazyQuery
>;
export type AuthorizedStringGroupsQueryResult = Apollo.QueryResult<
  AuthorizedStringGroupsQuery,
  AuthorizedStringGroupsQueryVariables
>;
export const GetAuthorizedStringGroupReviewHistoryDocument = gql`
  query GetAuthorizedStringGroupReviewHistory(
    $params: GetAuthorizedStringGroupReviewHistoryInput!
  ) {
    getAuthorizedStringGroupReviewHistory(params: $params) {
      stringGroups {
        stringGroupName
        requestId
        sourceReviewRequester
        sourceReviewRequestedTimestamp
        updatedBy
        updateTimestamp
        sourceReviewStatus
      }
    }
  }
`;

/**
 * __useGetAuthorizedStringGroupReviewHistoryQuery__
 *
 * To run a query within a React component, call `useGetAuthorizedStringGroupReviewHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizedStringGroupReviewHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizedStringGroupReviewHistoryQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetAuthorizedStringGroupReviewHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAuthorizedStringGroupReviewHistoryQuery,
    GetAuthorizedStringGroupReviewHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAuthorizedStringGroupReviewHistoryQuery,
    GetAuthorizedStringGroupReviewHistoryQueryVariables
  >(GetAuthorizedStringGroupReviewHistoryDocument, options);
}
export function useGetAuthorizedStringGroupReviewHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAuthorizedStringGroupReviewHistoryQuery,
    GetAuthorizedStringGroupReviewHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAuthorizedStringGroupReviewHistoryQuery,
    GetAuthorizedStringGroupReviewHistoryQueryVariables
  >(GetAuthorizedStringGroupReviewHistoryDocument, options);
}
export type GetAuthorizedStringGroupReviewHistoryQueryHookResult = ReturnType<
  typeof useGetAuthorizedStringGroupReviewHistoryQuery
>;
export type GetAuthorizedStringGroupReviewHistoryLazyQueryHookResult =
  ReturnType<typeof useGetAuthorizedStringGroupReviewHistoryLazyQuery>;
export type GetAuthorizedStringGroupReviewHistoryQueryResult =
  Apollo.QueryResult<
    GetAuthorizedStringGroupReviewHistoryQuery,
    GetAuthorizedStringGroupReviewHistoryQueryVariables
  >;
export const StringGroupDocument = gql`
  query StringGroup($params: StringGroupInput!) {
    stringGroup(params: $params) {
      stringGroupName
      cxFamily
      cxIds
      requestId
      sourceReviewRequester
      sourceReviewRequestedTimestamp
      reviewType
      approvalStatus
    }
  }
`;

/**
 * __useStringGroupQuery__
 *
 * To run a query within a React component, call `useStringGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useStringGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStringGroupQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useStringGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    StringGroupQuery,
    StringGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StringGroupQuery, StringGroupQueryVariables>(
    StringGroupDocument,
    options
  );
}
export function useStringGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StringGroupQuery,
    StringGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StringGroupQuery, StringGroupQueryVariables>(
    StringGroupDocument,
    options
  );
}
export type StringGroupQueryHookResult = ReturnType<typeof useStringGroupQuery>;
export type StringGroupLazyQueryHookResult = ReturnType<
  typeof useStringGroupLazyQuery
>;
export type StringGroupQueryResult = Apollo.QueryResult<
  StringGroupQuery,
  StringGroupQueryVariables
>;
export const IsAuthorizedForStringGroupDocument = gql`
  query IsAuthorizedForStringGroup($params: IsAuthorizedForStringGroupInput!) {
    isAuthorizedForStringGroup(params: $params) {
      authorized
    }
  }
`;

/**
 * __useIsAuthorizedForStringGroupQuery__
 *
 * To run a query within a React component, call `useIsAuthorizedForStringGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAuthorizedForStringGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAuthorizedForStringGroupQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useIsAuthorizedForStringGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsAuthorizedForStringGroupQuery,
    IsAuthorizedForStringGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IsAuthorizedForStringGroupQuery,
    IsAuthorizedForStringGroupQueryVariables
  >(IsAuthorizedForStringGroupDocument, options);
}
export function useIsAuthorizedForStringGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsAuthorizedForStringGroupQuery,
    IsAuthorizedForStringGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IsAuthorizedForStringGroupQuery,
    IsAuthorizedForStringGroupQueryVariables
  >(IsAuthorizedForStringGroupDocument, options);
}
export type IsAuthorizedForStringGroupQueryHookResult = ReturnType<
  typeof useIsAuthorizedForStringGroupQuery
>;
export type IsAuthorizedForStringGroupLazyQueryHookResult = ReturnType<
  typeof useIsAuthorizedForStringGroupLazyQuery
>;
export type IsAuthorizedForStringGroupQueryResult = Apollo.QueryResult<
  IsAuthorizedForStringGroupQuery,
  IsAuthorizedForStringGroupQueryVariables
>;
export const TranslationsDocument = gql`
  query Translations($params: TranslationInput!) {
    translations(params: $params) {
      translationList {
        phraseId
        phraseName
        sourceText
        format
        localization {
          locale
          translation
          lastUpdated
          lastUpdatedBy
        }
      }
      pageInfo {
        offset
        limit
        count
        totalCount
      }
    }
  }
`;

/**
 * __useTranslationsQuery__
 *
 * To run a query within a React component, call `useTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useTranslationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TranslationsQuery,
    TranslationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TranslationsQuery, TranslationsQueryVariables>(
    TranslationsDocument,
    options
  );
}
export function useTranslationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TranslationsQuery,
    TranslationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TranslationsQuery, TranslationsQueryVariables>(
    TranslationsDocument,
    options
  );
}
export type TranslationsQueryHookResult = ReturnType<
  typeof useTranslationsQuery
>;
export type TranslationsLazyQueryHookResult = ReturnType<
  typeof useTranslationsLazyQuery
>;
export type TranslationsQueryResult = Apollo.QueryResult<
  TranslationsQuery,
  TranslationsQueryVariables
>;
export const WhereIsMyStringDocument = gql`
  query WhereIsMyString($params: WimsRequestInput!) {
    whereIsMyString(params: $params) {
      localizedContent {
        content
        contentDebugModeMetadata {
          tmsName
          marketplace
          cmsName
          locale
          contentStage
          version
        }
        contentId
      }
      errorResponse {
        errorMessage
        errorCode
      }
    }
  }
`;

/**
 * __useWhereIsMyStringQuery__
 *
 * To run a query within a React component, call `useWhereIsMyStringQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhereIsMyStringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhereIsMyStringQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useWhereIsMyStringQuery(
  baseOptions: Apollo.QueryHookOptions<
    WhereIsMyStringQuery,
    WhereIsMyStringQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WhereIsMyStringQuery, WhereIsMyStringQueryVariables>(
    WhereIsMyStringDocument,
    options
  );
}
export function useWhereIsMyStringLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WhereIsMyStringQuery,
    WhereIsMyStringQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WhereIsMyStringQuery,
    WhereIsMyStringQueryVariables
  >(WhereIsMyStringDocument, options);
}
export type WhereIsMyStringQueryHookResult = ReturnType<
  typeof useWhereIsMyStringQuery
>;
export type WhereIsMyStringLazyQueryHookResult = ReturnType<
  typeof useWhereIsMyStringLazyQuery
>;
export type WhereIsMyStringQueryResult = Apollo.QueryResult<
  WhereIsMyStringQuery,
  WhereIsMyStringQueryVariables
>;
